import { useStateUtils } from '@/utils/deviceUtils/utils';

export const cottonStateUtils = useStateUtils({
  namespace: 'cotton',
  options: [
    { state: 0, color: '#03b36e ', text: '正常' },
    { state: 1, color: '#FF4847', text: '预警' }
  ],
  config: {
    state: 'state',
    text: 'text',
    alarmList: [1],
    normalList: [0]
  }
});

export const fireDetectionStateUtils = useStateUtils({
  namespace: 'cotton',
  options: [
    { state: -1, level: 2, color: '#949494 ', text: '离线' },
    { state: 0, level: 2, color: '#03b36e ', text: '在线' },
    { state: 2, Level: 4, color: '#FF4847', text: '报警' }
  ],
  config: {
    state: 'state',
    text: 'text',
    alarmList: [2],
    normalList: [0]
  }
});

export const fireDetectionRunstateUtils = useStateUtils({
  namespace: 'cotton',
  options: [
    { state: 1, level: 1, color: '#03b36e ', text: '在线' },
    { state: 3, level: 3, color: '#FF4847', text: '故障' }
  ],
  config: {
    state: 'state',
    text: 'text'
  }
});

export const cottonResultStateUtils = useStateUtils({
  namespace: 'cottonResult',
  options: [
    { state: -1, color: '#949494 ', text: '离线' },
    { state: 0, color: '#03b36e ', text: '正常' },
    { state: 1, color: '#FF6100', text: '待复检' },
    { state: 2, color: '#FF4847', text: '阴燃' }
  ],
  config: {
    state: 'state',
    text: 'text',
    alarmList: [0],
    normalList: [1]
  }
});
